import PropTypes from 'prop-types'
import React from 'react'

import styles from './marketplaceStats.module.css'

import { commaStyleString } from '../../../common/utils/formatString'

class MarketplaceStats extends React.Component {
  static propTypes = {
    stats: PropTypes.object
  }

  render() {
    let { stats } = this.props
    return (
      <ul className={styles.list}>
        {stats &&
        stats.total_users.toString() && (
          <li className={styles.listItem}>
            <span className={styles.stats}>
              {`${commaStyleString(stats.total_users)} `}
            </span>
            community members
          </li>
        )}
        {stats &&
        stats.total_items.toString() && (
          <li className={styles.listItem}>
            <span className={styles.stats}>
              {`${commaStyleString(stats.total_items)} `}
            </span>
            items for sale
          </li>
        )}
      </ul>
    )
  }
}

export default MarketplaceStats



// WEBPACK FOOTER //
// ./client/components/footer/marketplaceStats.js